'use strict'
module.exports = {
  NODE_ENV: '"uk"',

	// URLs
	APP_BASEURL: '"https://hermes-uk.protopia.co/"',
	API_BASEURL: '"https://api-uk.protopia.co/"',
	APP_REDIRECT_URL: '"https://protopia.co/maintenance"',

	// Auth0
	AUTH0_DOMAIN: '"protopia.auth0.com"',
	AUTH0_CLIENT: '"nciZjGbP8783X93rA9JfunzUskiINpu1"',
	AUTH0_CALLBACK: '"https://hermes-uk.protopia.co/callback"',

	// APIs
	NLP_API_KEY: '"AIzaSyCegHCm7-D-UWYjCFE6xQS56fO9Lnc4go8"',

	// Branding
	LOGO_URL: '"https://storage.googleapis.com/protopia/logos/logo_protopia_xs.png"',

	// LinkedIn Integration
	LINKEDIN_CLIENT_ID: '"86bm0xpurfqdqb"',
	LINKEDIN_CLIENT_SECRET: '"i0MwVy2mRbdJk5E7"',
	LINKEDIN_REDIRECT_URI: '"https://hermes.protopia.co/thank-you"',
	LINKEDIN_STATE_KEY: '"PROTOPIA"',

	// App Settings
	DEFAULT_EMAIL: '"team@protopia.co"',
	RANDOM_INTEREST_COUNT: 15,
	ADDITIONAL_PARAM_FRIENDLY_COUNT: 12,
  APP_REDIRECT_TIME: 10000,
  CAPTCHA_SITEKEY: '6LfHgiMrAAAAALk3kTrUj-W2VyU0IoueGX5w8sUi',
  VUE_APP_PROCESS_DASHBOARD_URL:'"https://hermes-uk.protopia.co/process-dashboard"',

	// Public base of the recruiting wizard.
	RECRUITING_BASEURL: '"https://opportunities.protopia.co"'
}



//////////////////
// WEBPACK FOOTER
// ./config/uk.env.js
// module id = 6EDN
// module chunks = 1